import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormSubmitButton from './FormSubmitButton';
import { TitleSection, FormWrapper, ButtonWrapper } from '../style';
import { red400 } from 'material-ui/styles/colors';

const ErrorText = styled.h3`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 1.6em;
    color: ${red400};
`;

function SectionList({ title, Component, submit, submitFailed = false, ...childrenProps }) {
    if (submitFailed) {
        return <ErrorText>Error saving!</ErrorText>;
    }

    return (
        <div>
            {title && <TitleSection>{title}</TitleSection>}
            <Component ListWrapper={FormWrapper} {...childrenProps} />
            <ButtonWrapper>
                <FormSubmitButton submit={submit} />
            </ButtonWrapper>
        </div>
    );
}

SectionList.propTypes = {
    title: PropTypes.string,
    Component: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]),
    submit: PropTypes.func.isRequired,
    submitFailed: PropTypes.bool
};

export default SectionList;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/UpdateAccount/SectionList.js
 **/